import { type ExamCenter } from '@exam-center/graphql';

export function mapExamCenterDetailsDefaultFormValues(
  examCenter: Pick<
    ExamCenter,
    | 'addressTH'
    | 'addressEN'
    | 'phoneTH'
    | 'phoneEN'
    | 'email'
    | 'examResultRecipientEmail'
    | 'website'
  >,
) {
  return {
    addressTH: examCenter.addressTH ?? '',
    phoneTH: examCenter.phoneTH ?? '',
    addressEN: examCenter.addressEN ?? '',
    phoneEN: examCenter.phoneEN ?? '',
    website: examCenter.website ?? '',
    email: examCenter.email ?? '',
    examResultRecipientEmail: examCenter.examResultRecipientEmail ?? '',
  };
}
